/**
 * Ergaenzt Shopifys natives Cookie-Einstellungen-Panel (#shopify-pc__prefs) um einen
 * Link zur Cookie-Details-Seite, da Shopifys Panel selbst keinen solchen Link anbietet.
 * Einbindung: snippets/cookie-prefs-details-link.liquid ({% render 'cookie-prefs-details-link' %})
 */
(function () {
  'use strict';

  var LINK_ID = 'shopify-pc__prefs__cookie-details-link';
  var LINK_HREF = '/pages/cookie-details';
  var LINK_TEXT = 'Genaue Auflistung aller Cookies ansehen (Cookie-Details)';

  function insertLink() {
    if (document.getElementById(LINK_ID)) return;
    var intro = document.querySelector('#shopify-pc__prefs .shopify-pc__prefs__intro-main');
    if (!intro) return;

    var p = document.createElement('p');
    p.id = LINK_ID;
    p.style.margin = '0.75em 0 0 0';

    var a = document.createElement('a');
    a.href = LINK_HREF;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = LINK_TEXT;
    a.style.textDecoration = 'underline';

    p.appendChild(a);
    intro.appendChild(p);
  }

  var observer = new MutationObserver(function () {
    if (document.getElementById('shopify-pc__prefs') && !document.getElementById(LINK_ID)) {
      insertLink();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  insertLink();
})();
